import { brandConfigMap, getBrandConfig, Brands, DefaultBrand } from '@/brand'

// Resolves the brand from the hosting origin, with ?brand=<id> as a local/preview override.
export default function setBrandConfig() {
  if (typeof window === 'undefined') return DefaultBrand

  const origin = (window.origin || window.location.origin || '').replace(/\/$/, '')
  let brandId = brandConfigMap.get(origin) || DefaultBrand

  const requested = new URLSearchParams(window.location.search).get('brand')
  if (requested && Object.values(Brands).includes(requested)) brandId = requested

  document.title = getBrandConfig(brandId).serviceName
  return brandId
}
